import React from 'react';
import BackButton from '../components/BackButton';
import TheReadableMind from '../components/TheReadableMind';

function TheReadableMindPage() {
  return (
    <>
      <BackButton />
      <TheReadableMind />
    </>
  );
}

export default TheReadableMindPage;
